var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgLinkedin(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33,
    height: 36,
    viewBox: "0 0 33 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_39_348)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30.5572 0H2.43633C1.08926 0 0 1.16016 0 2.59453V33.3984C0 34.8328 1.08926 36 2.43633 36H30.5572C31.9043 36 33 34.8328 33 33.4055V2.59453C33 1.16016 31.9043 0 30.5572 0ZM9.79043 30.6773H4.89199V13.493H9.79043V30.6773ZM7.34121 11.1516C5.76856 11.1516 4.49883 9.76641 4.49883 8.05781C4.49883 6.34922 5.76856 4.96406 7.34121 4.96406C8.90742 4.96406 10.1771 6.34922 10.1771 8.05781C10.1771 9.75937 8.90742 11.1516 7.34121 11.1516ZM28.1209 30.6773H23.2289V22.3242C23.2289 20.3344 23.1967 17.768 20.683 17.768C18.1371 17.768 17.7504 19.9406 17.7504 22.1836V30.6773H12.8648V13.493H17.557V15.8414H17.6215C18.2725 14.4914 19.8709 13.0641 22.2492 13.0641C27.2057 13.0641 28.1209 16.6219 28.1209 21.2484V30.6773Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_39_348"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 33,
    height: 36,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLinkedin);
export default __webpack_public_path__ + "static/media/linkedin.b12a8ee3ae1d26cce293de2f69d0bc21.svg";
export { ForwardRef as ReactComponent };